import { AssistantMessage } from '@/components/assistant/messages/AssistantMessage'
import { AssistantFeedItem } from '@/store/assistant'
import { useStoreState } from '@/store/hooks'
import { useT } from '@repo/ui/hooks'
import { CheckCircle, Loader2 } from 'lucide-react'
import { memo, useEffect, useState } from 'react'

export const ProcessingMessageHanlder = memo(function ({
  item,
  isThinking,
}: {
  item: AssistantFeedItem
  isThinking: boolean
}) {
  const generationId = useStoreState((state) => state.assistant.generationId)

  const [hasStoppedThinking, setHasStoppedThinking] = useState(false)

  useEffect(() => {
    if (!isThinking) {
      setHasStoppedThinking(true)
    }
  }, [isThinking])

  if (item.type !== 'processingMessage') return null
  if (generationId !== item.generationId) return null
  if ('contentWhileProcessing' in item) {
    return (
      <CustomMessage
        key={item.id}
        isProcessing={!hasStoppedThinking && isThinking}
        whileProcessing={item.contentWhileProcessing}
        afterProcessing={item.contentAfterProcessing}
      />
    )
  }
  if ('transKeyWhileProcessing' in item) {
    return (
      <CustomMessage
        key={item.id}
        isProcessing={!hasStoppedThinking && isThinking}
        whileProcessing={item.transKeyWhileProcessing}
        afterProcessing={item.transKeyAfterProcessing}
        isTranslatable
      />
    )
  }
})

function CustomMessage({
  afterProcessing,
  isProcessing,
  isTranslatable = false,
  onProcessingEnd,
  whileProcessing,
}: {
  afterProcessing: string
  isProcessing: boolean
  isTranslatable?: boolean
  onProcessingEnd?: () => void
  whileProcessing: string
}) {
  const { t } = useT({ keyPrefix: 'assistant' })
  useEffect(() => {
    if (!isProcessing) onProcessingEnd?.()
  }, [isProcessing])

  return (
    <AssistantMessage className="flex gap-2">
      {isProcessing ? (
        <>
          <Loader2 className="min-h-5 min-w-5 animate-spin" />
          <span>{isTranslatable ? t(whileProcessing) : whileProcessing}</span>
        </>
      ) : (
        <>
          <CheckCircle className="min-h-5 min-w-5" />
          <span>{isTranslatable ? t(afterProcessing) : afterProcessing}</span>
        </>
      )}
    </AssistantMessage>
  )
}
